<template>
  <div class="staff_management_record">
    <div class="tit">
      <span>员工管理|<span class="right">已认证企业在此对员工身份进行认证，认证后员工发起的会议室预定、加班申请等产生的费用将列入企业缴费清单，请务必严格审核</span></span>
    </div>
    <!-- 有企业，有员工 -->
    <div class="body_content" v-if="tableSwitch === 1">
      <myTable :tableObj="tableObj" @btnClick="btnClick" @changePageNo="getList"></myTable>
    </div>
    <!-- 员工身份，还没认证企业 -->
    <div class="body_content" v-if="tableSwitch === 2">
      <span>您已认定为员工身份，不能进行员工管理哦</span>
      <!-- <el-button type="primary" @click="goCertification">去认证</el-button> -->
      <!-- <span style="margin-left:10px">您可以在此认证为企业身份，认证后可进行员工管理等操作</span> -->
    </div>
    <!-- 普通用户 -->
    <div class="body_content" v-if="tableSwitch === 3">
      <div class="btns">
        <div class="btn_left">
          <div class="tip">您目前为普通用户，请前往进行员工认证或者企业认证</div>
          <el-button type="primary" @click="employeeCertify">员工认证</el-button>
          <el-button type="primary" @click="enterpriseCertify">企业认证</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import myTable from "@/components/my_table";
export default {
  components:{
    myTable
  },
  data(){
    return{
      tableObj: {
        list: [], //列表数据
        btns: [
          //按钮组
          {
            name: "查看详情",
            funcName:'checkDetail'
          },
          {
            name: "通过",
            funcName:'passCertificate',
            // 已提交时显示
            formatter: (row)=>{
              return row.status_code == 'IdentityCertifieStatusSubmitted'
            }
          },
          {
            name: "不通过",
            funcName:'nopassCertificate',
            // 已提交时显示
            formatter: (row)=>{
              return row.status_code == 'IdentityCertifieStatusSubmitted'
            }
          }
        ],
        table_detail: [
          //table详情
          {
            prop: "name",
            label: "员工姓名"
          },
          {
            prop: "mobile",
            label: "联系方式",
            width:"115px"
          },
          {
            prop: "sex_name",
            label: "性别"
          },
          {
            prop: "job_num",
            label: "工号"
          },
          {
            prop: "department",
            label: "部门"
          },
          {
            prop: "position",
            label: "职位"
          },
          {
            prop: "incubator_name",
            label: "申请园区"
          },
          {
            prop: "enterprise_name",
            label: "企业名称"
          },
          {
            prop: "status_name",
            label: "审批状态"
          }
        ],
        layerpageinfo: {
          //分页
          pageNo: 0,
          total: 0,
          pageSize: 10
        }
      },
      tableSwitch: 0, //模块展示判断
      id:'',          //table行id
    }
  },
  created(){ 
    if (this.$store.state.info) {
      this.getList(); /** 查询认证 用于二次编辑*/
    } else {
      this.needInfo("getList");
    }
    // 获取是否企业认证
    // this.getFrontAuthenticates()
  },
  computed: {
    info() {
      return this.$store.state.info;
    }
  },
  methods:{
    // 获取员工列表
    getList(){
      // 若为普通用户，显示员工认证模块
      if(this.$store.state.info.role === "UserRoleOrdinary"){
        this.tableSwitch = 3 
      }else if(this.$store.state.info.role === "UserRoleEmployee"){
        // 员工身份
        this.tableSwitch = 2
      }else{
        let obj = {
          ...this.tableObj.layerpageinfo,
          // user_id: sessionStorage.getItem("userId")
        }
        // 企业下员工列表
        this.api.getAuthenticateEmployees(obj)
          .then(res => {
            console.log(res)
            if (res.error.err_code != 0) return;
            let list = res.obj.list || [];
            this.tableObj.list = list;
            this.tableObj.layerpageinfo.total = res.obj.totalSize;
            this.tableSwitch = 1;
          })
      }
    },
    // 操作按钮
    btnClick(btn){
        switch(btn.btnFuncName){
            // 查看详情
            case "checkDetail":
              this.$router.push({
                  path:'/personal_center/enterprise/staff_management/staff_manegement_detail',
                  query:{
                    id:btn.row.id
                  }
              })
              break;
            // 通过
            case "passCertificate":
              this.$confirm(`您确定同意${btn.row.name}的员工认证吗？`, '提示', {
                confirmButtonText: '同意',
                cancelButtonText: '取消',
                type: 'warning'
              })
              .then(() => {
                this.id = btn.row.id;
                this.passVerification()
              })
              .catch(() => {
                return
              });
              
              break;
            // 不通过
            case "nopassCertificate":
              this.$confirm(`您确定拒绝${btn.row.name}的员工认证吗？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              })
              .then(() => {
                this.id = btn.row.id;
                this.nopassVerification()
              })
              .catch(() => {
                return
              });
              break;
        }
    },
    // 通过审核
    passVerification(){
      this.api.authenticateEmployeeApproval({
        id:this.id,
        operation:'IdentityCertifieStatussuccess',
        examine_remark:'审核通过'  
      })
      .then(res => {
        console.log(res)
        if(res.error.err_code != 0) return;
        this.$message({
          type: 'success',
          message: '您已同意！'
        });
        // 重新获取列表
        this.getList()
      })
    },
    // 不通过审核
    nopassVerification(){
      this.api.authenticateEmployeeApproval({
        id:this.id,
        operation:'IdentityCertifieStatusFailed',
        examine_remark:'审核不通过'  
      })
      .then(res => {
        console.log(res)
        if(res.error.err_code != 0) return;
        this.$message({
          type: 'success',
          message: '您已拒绝！'
        });
        // 重新获取列表
        this.getList()
      })
    },
    // 获取是否认证企业
    // getFrontAuthenticates(){
    //   let obj = {}
    //   this.api.getFrontAuthenticates(obj)
    //   .then(res => {
    //     console.log(res)
    //     if (res.error["err_code"] !== 0) return;
    //     let list = res.obj.list || [];
    //     console.log(list)
    //     this.tableSwitch = list.length ? 1 : 2;
    //   })
    // },
    // 去认证
    // goCertification(){
    //   this.$router.push({
    //     path:'/personal_center/enterprise/enterprise_certification/enterprise_certificaiton_table_list'
    //   })
    // },
    needInfo(name) {
      let watchAch = this.$watch("info", (val, oldVal) => {
        if (val) {
          this[name]();
          watchAch(); //取消监听
        }
      });
    },
    // 员工认证
    employeeCertify(){
      this.$router.push({ name: "employee_certification" });
    },
    // 企业认证
    enterpriseCertify(){
      this.$router.push({ name: "enterprise_certification" });
    }
  },
  
  
}
</script>

<style lang="scss">
@import "../../../index.scss";
.staff_management_record{
  .tit{
    // line-height: 20px;
    .right{
      font-size: 12px;
      font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;
    }
  }
  .body_content{
    .btns{
      .btn_left{
        .tip{
          line-height: 30px;
          font-size: 18px;
        }
      }
    }
  }
}
</style>